(function() {

    // Add the directive to the module
    angular.module("Sinewav3.Client.Shell")
        .directive(
            'assetControl',
            [
                'CHROME',
                AssetControlFactory
            ]
        );

    // Factory Method
    function AssetControlFactory(CHROME)
    {
        // Construct and return the instance
        return {
            restrict: 'E',
            templateUrl: CHROME.PREFIX + CHROME.PROJECT.CONTROL.ASSET + CHROME.POSTFIX
        };

    }
})();



